import React from 'react'
import { NavLink } from 'react-router-dom'

export default function UserListGroup() {
  return (
    <>
       <div className="list-group">
       <NavLink
        title='v hotel the grand shoba my account '
          to="/my-account"
          className="list-group-item list-group-item-action  mb-1"
          aria-current="true"
        >
            <i className="fa fa-home fs-4"></i>
          <span className="float-end">HOME</span>
        </NavLink>
        <NavLink
         title='v hotel the grand shoba user-booking '
          to="/user-booking"
          className="list-group-item list-group-item-action  mb-1"
          aria-current="true"
        >
            <i className="fa fa-home fs-4"></i>
          <span className="float-end">BOOKINGS</span>
        </NavLink>
        <NavLink
         title='v hotel the grand shoba  user-offer'
          to="/user-offer"
          className="list-group-item list-group-item-action  mb-1"
          aria-current="true"
        >
            <i className="fa fa-home fs-4"></i>
          <span className="float-end">OFFERS</span>
        </NavLink>
        <NavLink
         title='v hotel the grand shoba user support'
          to="/user-support"
          className="list-group-item list-group-item-action  mb-1"
          aria-current="true"
        >
            <i className="fa fa-home fs-4"></i>
          <span className="float-end"> SUPPORT</span>
        </NavLink>
       </div>

    </>
  )
}
